import * as React  from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as _ from 'lodash';
import JSZip from 'jszip';

import { CombinedViewConstants } from "../../../containers/WorkkardDetail/constants";
import { fetchCombinedViewData, updateCombinedViewData,sortCombinedView,
     resetCombinedView,resetCombinedViewData,fetchPrintCombinedViewData,resetPrintPreviewData, getsavednotefilters, fetchCombinedViewWorkkardFiles } from "../../../containers/WorkkardDetail/actions/action";
import LoaderComponent from '../../../components/Loader';
import {NoteListingLoader} from '../../../components/SkeletonLoader';
import CombineViewGroup from './combineViewGroup';
import { combinedViewDateKey, combinedViewTime } from './dateKey';
import { buildCombinedViewParams } from '../Saga/combineView';
import ListingComponent from '../../../components/ListingComponent';
import Icons from '../../../icons';
import { showDialogueBox,hideDialogueBox } from '../../../components/DialogueBox/actions';
import PrintCombinedView from "./printCombinedView";
import EmptyScreen from '../../../Emptyscreen';
import { isMobile, fetchDownload, triggerBlobDownload } from '../../../common/util';

/** Entries requested per scroll page. */
const PAGE_SIZE = 50;

export default function CombinedView() {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.isLoading);
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const combinedView = useSelector(state => state.workkardDetail.combinedView);
    const entries = useSelector(state => state.workkardDetail.combinedView.entries);
    const sessionContext = useSelector(state => state.sessionContextOidc);
    const noteFilters = useSelector(state => state.workkardDetail.middlePanel.activityNoteTemplates);
    const panelVisibility = useSelector(state => state.workkardDetail.panelVisibility);
    const activityListing = useSelector(state => state.workkardDetail.activityListing);
    const workkardFiles = useSelector(state => state.workkardDetail.combinedView.workkardFiles) || [];

    const [isZipDownloading, setIsZipDownloading] = useState(false);

    useEffect(() => {
        const payload = {
            id: workkard.Id,
            start: 0,
            end: 50,
            fetchdata: false
        };
        dispatch(getsavednotefilters({
            cId: workkard.Id,
            combined: true,
            callback: () => {
                dispatch(fetchCombinedViewData(payload));
            },
        }));

        return () => {
            isMobile() ? null : dispatch(resetCombinedView());
        };
    }, []);

    useEffect(() => {
        if (!workkard.Id) return;
        dispatch(fetchCombinedViewWorkkardFiles({ cId: workkard.Id }));
    }, [workkard.Id, (activityListing.activities || []).length]);

    // Profile hydration used to happen here by scraping ids out of the rendered
    // DOM with jQuery and writing the resolved names and avatars back into
    // React-owned nodes. Both halves are gone: each page now reports the user
    // and org ids it references, and the saga hydrates the shared stores that
    // the templates read through selectors.

    const prevFiltersCountRef = useRef(Object.keys(combinedView.filters).length);
    useEffect(() => {
        const prevCount = prevFiltersCountRef.current;
        const currCount = Object.keys(combinedView.filters).length;
        if (!panelVisibility.isLeftVisible && prevCount !== currCount) {
            const payload = {
                id: workkard.Id,
                start: 0,
                end: 50,
                fetchdata: true
            };
            dispatch(fetchCombinedViewData(payload));
        }
        prevFiltersCountRef.current = currCount;
    }, [combinedView.filters]);

    function onScrollHandler() {
        // The window advances by a page; `total` is the server's count of every
        // entry matching the current filters, so it is the stop condition.
        const start = parseInt(combinedView.start || 0, 10);
        const payload = {
            cId: workkard.Id,
            start: start + PAGE_SIZE,
            end: PAGE_SIZE,
        }
        if (entries.length < combinedView.total) {
            dispatch(updateCombinedViewData(payload));
        }
    }

    function renderCombineView(entries) {
        if (entries && entries.length > 0) {
            const dataIds = entries.map(entry => {
                // An activity note that carries neither text nor an attachment
                // and records no resolution change has nothing to render.
                if (entry.type === CombinedViewConstants.entryType.activityNote
                    && !(entry.note && entry.note.body)
                    && (!entry.files || entry.files.length === 0)) {
                    return "";
                }
                return {
                    id: entry.id,
                    date: combinedViewDateKey(entry.occurred_at),
                    time: combinedViewTime(entry.occurred_at),
                    data: entry
                }
            }).filter(item=>item!='');
            const groupDataIds = _.groupBy(dataIds, 'date');
            const hasFiles = (workkard.DocCount+workkard.PhotoCount+workkard.VideoCount+workkard.AudioCount+workkard.EmailCount+workkard.OtherCount) > 0 ? true : false;
            const prop = {
                data: Object.keys(groupDataIds).map(key=>({key,data:groupDataIds[key]})),
                cellTemplate: CombineViewGroup,
                onScrollHandler: onScrollHandler,
                onItemClick: () => false,
                type: "div",
                selectedId: '',
                classname: 'scrollArea combinedScroll',
                extraData: { workkardId: workkard.Id, cvSettings: combinedView.filters.contentFilter, hasFiles: hasFiles, resetCombinedViewData: () => dispatch(resetCombinedViewData()) }
            }

            return (
                <ListingComponent {...prop}/>
            );
        }
        return <EmptyScreen name="EmptyCombinedView" />;
    }

    function applySort() {
        const payload = { settings: Object.assign({}, combinedView.filters.contentFilter, {IsSortedAscending: combinedView.filters.contentFilter.IsSortedAscending ? false : true}) }
        dispatch(sortCombinedView(payload));
    }

    async function downloadAllFilesAsZip() {
        if (workkardFiles.length === 0 || isZipDownloading) return;
        setIsZipDownloading(true);
        try {
            const zip = new JSZip();
            await Promise.all(workkardFiles.map(async (file) => {
                const fileResponse = await fetchDownload(file.FileGuid);
                zip.file(file.FileName, fileResponse.data);
            }));
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            triggerBlobDownload(zipBlob, `${workkard.WorkkardNumber}.zip`);
        } catch (e) {
            console.log(e);
        } finally {
            setIsZipDownloading(false);
        }
    }

    function getFilterString(settings, isActFilter) {
        const appliedFilters = _.keys(_.pickBy(settings, function(val){ return typeof val == "boolean" && val }))
        let actFilters = [], wkFilters = []
        let filterStr;
        let isShowAllNoteTemplates = combinedView.showAllTemplates;
        appliedFilters.forEach(f => {
            if (f.indexOf("Activity") == 0) {
                actFilters.push(f.replace("Activity", "").toLowerCase())
            } else if (f.indexOf("Workkard") == 0) {
                wkFilters.push(f.replace("Workkard", "").toLowerCase())
            }
        })
        if (wkFilters.length === 4 && actFilters.length === 4 && !isActFilter && isShowAllNoteTemplates) {
            filterStr = `Currently all Notes, Logs, Actions & Files  are being displayed`
        } else {
            filterStr = `Currently ${wkFilters.length ? `all Workkard ${wkFilters.join(", ")}` : ''} ${actFilters.length ? `${wkFilters.length ? '&':''} ${(isActFilter || !isShowAllNoteTemplates) ? 'selected' : wkFilters.length ? '':'all'} Activity ${actFilters.join(", ")}` : ''}  are being displayed`
        }
        return filterStr
    }

    function handlePrintCombinedView() {
        const payload = buildCombinedViewParams({
            workkardId: workkard.Id,
            settings: combinedView.filters.contentFilter,
            activityIds: combinedView.activity,
            userIds: combinedView.users,
            ascending: combinedView.settings.IsSortedAscending,
            sdate: combinedView.date.sdate || "",
            edate: combinedView.date.edate || "",
            dntids: combinedView.showAllTemplates ? "" : combinedView.dntids
        });
        delete payload.start;
        delete payload.end;

        dispatch(fetchPrintCombinedViewData(payload));
        dispatch(showDialogueBox({
            flag: true,
            component: <PrintCombinedView sessionContext={sessionContext} onClose={() => handleDialogueBoxClose()}/>,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        }))
    }

    function handleDialogueBoxClose() {
        dispatch(resetPrintPreviewData());
        dispatch(hideDialogueBox());
    }

    const { settings, activity, filters } = combinedView;
    const downloadDisabled = (workkardFiles.length > 0) ? false : true;
    const isActFilter = activity && activity.length > 0 && activity.length < filters.activityTitle.length;
    const sortDisabled = (entries.length > 0) ? false : true;
    const printDisabled = (entries.length > 0) ? false : true;
    return (
        <div>
            <div className="detailHeader">
                <div className="detailHeaderLeft">
                    <h1 className="mr orange">{workkard.WorkkardNumber}</h1>
                </div>
                <div className="detailHeaderRight alignMiddle">
                    <div className="downloadAll quickTooltip-bottom" data-quicktooltip={downloadDisabled ? null : "Download all workkard & activity files"}>
                        <a href="javascript:void(0);" className={`mr downloadLink ${downloadDisabled ? 'disabled' : 'linkBlack'}`} id="downloadAll" onClick={downloadDisabled ? ()=>{return null} : downloadAllFilesAsZip} disabled={downloadDisabled}><Icons name="download" className="icon" /> Download all files</a>
                    </div>
                    <div className="sort quickTooltip-bottom" data-quicktooltip={!sortDisabled ? (combinedView.settings.IsSortedAscending ? "sort by descending order" : "sort by ascending order") : null}>
                        <a className="sort" href="javascript:void(0)" onClick={sortDisabled ? ()=>{return null} : applySort}><Icons name={combinedView.settings.IsSortedAscending ? "SortbyOld" : "sort"} className={`icon mr ${sortDisabled ? 'disabled' : ''}`}/></a>
                    </div>
                    <div>
                        <a className="quickTooltip-bottom" data-quicktooltip="Print Preview" id="printCV" href="javascript:void(0)" onClick={printDisabled ? ()=>{return null} : handlePrintCombinedView}><Icons name="print" className={`icon ${printDisabled ? 'disabled' : ''}`} /></a>
                    </div>
                </div>
            </div>
            {
               (isLoading && entries && entries.length < 1) ?
                <NoteListingLoader count={5} />
                :
                (
                    <>
                    {entries && entries.length > 0 && <div className="textCenter stickInfoBanner">
                        {getFilterString(settings, isActFilter)}
                    </div>}
                    <div className="emptyDiv"></div>
                    <div className={"combined-view combinedViewData animated fast fadeIn"}>
                        {/* <div className="date"><span>{groupDataIds && Object.entries(groupDataIds).length > 0 && <Date inputDate={Object.keys(groupDataIds).map(key=>({key,data:groupDataIds[key]}))} /> }</span></div> */}
                        {
                            <div className={(entries && entries.length == 0) ? "combinedMainContainer detailMainContainer noDataFound" : "combinedMainContainer detailMainContainer"}>
                                {renderCombineView(entries)}
                            </div>
                        }
                        {
                            ((isLoading && entries && entries.length > 0) || isZipDownloading) &&
                            <LoaderComponent />
                        }
                    </div>
                    </>
                )
            }
        </div>
    );
}

